// extracted by mini-css-extract-plugin
export default {"modal":"lca","heading":"mca","product":"nca","note":"oca","notetitle":"pca","notetext":"qca","line":"rca","plan":"sca","planimage":"tca","description":"uca"};
    if(module.hot) {
      // 1715276860328
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  